import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, TemplateRef } from '@angular/core';
import { Project } from '@rappider/rappider-sdk';
import { Store } from '@ngrx/store';
import { selectActiveProject } from 'libs/project/src/lib/states/active-project-state/active-project.selectors';
import { Subscription } from 'rxjs';

import {
  projectInformationFormConfig,
  projectInformationTitle,
  projectInformationOptiontitle
} from './utils';
import { exportCards } from './utils/export-cards-config';
import { BACKEND_FRAMEWORK_TYPES, FRONTEND_FRAMEWORK_TYPES } from 'libs/shared/src/lib/definitions/project-version-definitions';
import { UpdateProject } from 'libs/project/src/lib/states/projects-state/project.actions';

@Component({
  selector: 'rappider-project-information',
  templateUrl: './project-information.component.html',
  styleUrls: ['./project-information.component.scss']
})
export class ProjectInformationComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('customTemplate') customTemplate!: TemplateRef<any>;


  activeProject: Project | undefined;
  projectInformationTitle = projectInformationTitle;
  projectInformationOptiontitle = projectInformationOptiontitle;
  informationConfig = projectInformationFormConfig;

  displayToolbar = false;
  displayToolbarBackButton = false;
  exportCards = exportCards;
  exportCardsSelectOptions = [{ key: FRONTEND_FRAMEWORK_TYPES.ANGULAR.key, value: FRONTEND_FRAMEWORK_TYPES.ANGULAR.value }, { key: FRONTEND_FRAMEWORK_TYPES.MOBILE.key, value: FRONTEND_FRAMEWORK_TYPES.MOBILE.value }, { key: BACKEND_FRAMEWORK_TYPES.LOOPBACK4.key, value: BACKEND_FRAMEWORK_TYPES.LOOPBACK4.value }];
  private subscriptions: Subscription[] = [];

  constructor(private store: Store) {
  }

  ngOnInit() {
    this.subscribeToData();
  }

  ngAfterViewInit() {
    this.exportCards = this.exportCards.map(card => ({
      ...card,
      customTemplate: this.customTemplate,
    }))
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  subscribeToData() {
    this.subscriptions = [
      this.subscribeToActiveProject()
    ];
  }

  subscribeToActiveProject() {
    return this.store.select(selectActiveProject).subscribe((activeProject: Project | undefined) => {
      if (activeProject?.id) {
        this.activeProject = activeProject;
      }
    });
  }

  onCheckboxValueChange(value) {
    let codeGenerationTemplateIds = this.activeProject?.codeGenerationTemplateIds;
    if(value.check === true && !codeGenerationTemplateIds?.includes(value.id)){
      codeGenerationTemplateIds = [...codeGenerationTemplateIds, value.id];
    }
    if(value.check === false && codeGenerationTemplateIds?.includes(value.id)){
      codeGenerationTemplateIds = codeGenerationTemplateIds?.filter(templateId=>templateId !== value.id);
    }
    if (this.activeProject?.id) {
      this.store.dispatch(new UpdateProject({
        project: {
          codeGenerationTemplateIds
        },
        projectId: this.activeProject.id,
        redirectToProjectDetail: false
      }));
    }

  }
}
